/**
 * 修改素材名称
 */
import { computed, defineComponent, ref } from '@vue/composition-api';
// import { useSplitTestTool } from '@/hooks/creation/splittest/use-split-test-tool';
import { getFileNameAndExtension } from '@tt4b/ttam-utils';
import { useMaterialNameValidate } from '@tt4b/ttam-hooks';

export default defineComponent({
  props: {
    fileName: {
      type: String,
      default: '',
    },
    renderTool: {
      type: String,
      default: '',
    },
    renderStatus: {
      type: String,
      default: '',
    },
  },
  setup(props, ctx) {
    const refForm = ref();
    const isShowPopover = ref(false);
    const btnLoading = ref(false);
    // TODO 待splittest支持
    // const { disableSplitTestSwitch } = useSplitTestTool();

    const name = ref(getFileNameAndExtension(props.fileName).excludeExtName);

    const currentFileName = computed({
      get() {
        return name.value;
      },
      set(val: string) {
        name.value = val;
      },
    });

    const getName = () => {
      if (isShowPopover.value) {
        name.value = getFileNameAndExtension(props.fileName).excludeExtName;
      }
    };

    const handleClosePopover = () => {
      isShowPopover.value = false;
      btnLoading.value = false;
    };

    const handleSubmit = () => {
      if (currentFileName.value === props.fileName) {
        handleClosePopover();

        return;
      }

      btnLoading.value = true;
      //   disableSplitTestSwitch(true);

      refForm.value.validate(isValid => {
        // disableSplitTestSwitch(false);
        btnLoading.value = false;
        if (isValid) {
          const { extension } = getFileNameAndExtension(props.fileName);
          handleClosePopover();
          ctx.emit('change', `${name.value}${extension}`);
        }
      });
    };

    /** 表单校验相关逻辑 START */
    const validateName = (rule, value, callback, formData) => {
      const fileName = formData.name;

      // 命名检查
      return useMaterialNameValidate({ targetName: fileName })
        .then(data => {
          const { type, msg } = data;
          if (type) {
            return callback(msg);
          }

          return callback();
        })
        .catch(() => {
          btnLoading.value = false;
        });
    };
    const rules = computed(() => ({ name: [{ validator: validateName, trigger: 'custom' }] }));
    /** 表单校验相关逻辑 END */

    return {
      name,
      refForm,
      currentFileName,
      isShowPopover,
      getName,
      handleClosePopover,
      handleSubmit,
      btnLoading,
      rules,
    };
  },
});
